export default function escapeForHtml(input: string): string {
  const element = document.createElement('div');
  element.innerText = input;
  return element.innerHTML;
}
